var exports = {
  "XG": "ChannelAttachmentArea.module__scroller___QnA2RX",
  "IP": "ChannelAttachmentArea.module__channelAttachmentArea___QnA2RX",
  "Se": "ChannelAttachmentArea.module__upload___QnA2RX",
  "PO": "ChannelAttachmentArea.module__uploadContainer___QnA2RX",
  "il": "ChannelAttachmentArea.module__mediaContainer___QnA2RX",
  "BA": "ChannelAttachmentArea.module__clickableMedia___QnA2RX",
  "q2": "ChannelAttachmentArea.module__spoilerContainer___QnA2RX",
  "R": "ChannelAttachmentArea.module__hidden___QnA2RX",
  "rP": "ChannelAttachmentArea.module__hiddenSpoiler___QnA2RX",
  "pR": "ChannelAttachmentArea.module__spoilerWarning___QnA2RX",
  "Qx": "ChannelAttachmentArea.module__obscureWarning___QnA2RX",
  "Qu": "ChannelAttachmentArea.module__spoilerInnerContainer___QnA2RX",
  "CU": "ChannelAttachmentArea.module__spoilerWrapper___QnA2RX",
  "p6": "ChannelAttachmentArea.module__spoiler___QnA2RX",
  "$_": "ChannelAttachmentArea.module__media___QnA2RX",
  "_A": "ChannelAttachmentArea.module__tags___QnA2RX",
  "H6": "ChannelAttachmentArea.module__filenameContainer___QnA2RX",
  "iW": "ChannelAttachmentArea.module__filename___QnA2RX",
  "VF": "ChannelAttachmentArea.module__fileDetails___QnA2RX",
  "Ov": "ChannelAttachmentArea.module__fileSize___QnA2RX",
  "i_": "ChannelAttachmentArea.module__fileExtension___QnA2RX",
  "TC": "ChannelAttachmentArea.module__actionBarContainer___QnA2RX",
  "KY": "ChannelAttachmentArea.module__actionBar___QnA2RX" + " " + __webpack_require__(180357)["KE"],
  "x6": "ChannelAttachmentArea.module__button___QnA2RX" + " " + __webpack_require__(180357)["AS"],
  "OR": "ChannelAttachmentArea.module__danger___QnA2RX",
  "le": "ChannelAttachmentArea.module__actionBarIcon___QnA2RX",
  "s3": "ChannelAttachmentArea.module__altTag___QnA2RX",
  "Kk": "ChannelAttachmentArea.module__icon___QnA2RX",
  "Dp": "ChannelAttachmentArea.module__iconImage___QnA2RX",
  "vt": "ChannelAttachmentArea.module__videoModal___QnA2RX",
  "j": "ChannelAttachmentArea.module__videoContainer___QnA2RX",
  "yF": "ChannelAttachmentArea.module__divider___QnA2RX",
  "mg": "ChannelAttachmentArea.module__dropIndicatorLeft___QnA2RX",
  "l_": "ChannelAttachmentArea.module__dropIndicatorRight___QnA2RX",
};

module.exports = exports;
